import React, { forwardRef } from 'react';
import './FullScreenProject.css';

const FullScreenProject = forwardRef(({
  backgroundColor,
  backgroundImage,
  logo,
  projectName,
  header,
  subheader,
  learnMoreUrl,
  children
}, ref) => {
  return (
    <section
      className="full-screen-project"
      ref={ref}
      style={{ backgroundColor }}
    >
      <div className="project-left">
        <div className="content-wrapper">
          {header && <h1 className="project-header">{header}</h1>}
          {subheader && <p className="project-subheader">{subheader}</p>}
          {logo && <img src={logo} alt="Project logo" className="project-logo" />}
          {projectName && <h2 className="project-name">{projectName}</h2>}
          {learnMoreUrl && (
            <a 
              href={learnMoreUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="learn-more-button"
            >
              Learn More
            </a>
          )}
          {children}
        </div>
      </div>
      <div
        className="background-image"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
    </section>
  );
});

export default FullScreenProject;
